import React from 'react';
import { Box, Typography } from '@mui/material';

const CANCELED_OUTCOME = 17;

// Renders the inner content of a calendar event. The coloured wra
// pper around it
// is handled by the calendar's eventPropGetter; this only owns the typography.
const EventCard = function EventCard({ event }) {
  const isCanceled = event?.outcome === CANCELED_OUTCOME;
  const isCompleted = Boolean(event?.outcome) && event?.outcome !== 100;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        minWidth: 0,
      }}
    >
      {isCompleted && !isCanceled && (
        <Box
          component="span"
          sx={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            flexShrink: 0,
            bgcolor: 'currentColor',
            opacity: 0.7,
          }}
        />
      )}
      <Typography
        component="span"
        noWrap
        sx={{
          fontSize: '0.75rem',
          fontWeight: 600,
          lineHeight: 1.3,
          textDecoration: isCanceled ? 'line-through' : 'none',
        }}
      >
        {event?.title}
      </Typography>
    </Box>
  );
};

export default EventCard;
